// Control IDs for the Smart Reports page (sai's smart-report IDs, mapped to ours
// by toTrapezium: smart-report.* -> product.smart-reports.*).
import { toTrapezium as t } from './sai/trapezium';

export const IDS = {
  step: (key) => t(`smart-report.show-step-${key}`), // pdf | lengths | pack | mono | premium
  template: (key) => t(`smart-report.template-${key}`), // personal | compact | total
  fullReport: t('smart-report.full-report'), // step 2: the rest of the report is locked; goes to /next-step
  premium: (key) => t(`smart-report.premium-${key}`), // consolidated | quick-health | body-summary | diet (step 5)
  card: (key) => t(`smart-report.card-${key}`), // see DECK in SmartReports.jsx
  page: { prev: t('smart-report.page-prev'), next: t('smart-report.page-next') },
  compare: t('smart-report.compare'), // range 4..96, colour | mono
  showcaseSound: t('smart-report.showcase-sound'), // the showreel above the steps: sound on / off
  playDemo: t('smart-report.play-demo'), // play / pause for that showreel
  more: t('smart-report.next'), // next step, or the next product on the last step
};
